import styled from "styled-components";

export const Wrapper = styled.div`
	height: 100vh;
	z-index: 1000;
	position: relative;

	@media only screen and (max-width: 800px) {
		height: 100%;
		background: #13141b;
	}
`;

export const BackgroundContainer = styled.div`
	position: fixed;
	height: 100%;
	width: 100%;
	background: #13141b;
`;
